export default __webpack_public_path__ + "static/media/csharp.044bc7e0.svg";